// Arquivo: InventoryPdfDocument.tsx
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { StockInventoryReportItem } from "../Types/StockInventory.types";
import { PdfLayout } from "./PdfLayout"; // <-- 1. Importe o Layout

// 2. Mantenha apenas os estilos da tabela
const styles = StyleSheet.create({
  table: {
    display: "flex",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: { flexDirection: "row", backgroundColor: "#fff" },
  tableRowAlternate: { flexDirection: "row", backgroundColor: "#f2f2f2" },
  tableColHeader: {
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#d3d3d3",
    padding: 5,
  },
  tableCol: {
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 5,
  },
  codeCol: { width: "30%" },
  nameCol: { width: "50%" },
  countCol: { width: "20%" },
  tableCellHeader: { fontSize: 10, fontFamily: "Helvetica-Bold" },
  tableCell: { fontSize: 9 },
});

type Props = { data: StockInventoryReportItem[] };

export function InventoryPdfDocument({ data }: Props) {
  const reportDate = new Date().toLocaleDateString("pt-BR");

  return (
    // 3. Use o Layout
    <PdfLayout title={`Relatório de Inventário - ${reportDate}`}>
      <View style={styles.table}>
        <View style={styles.tableRow} fixed>
          <View style={[styles.tableColHeader, styles.codeCol]}>
            <Text style={styles.tableCellHeader}>Código</Text>
          </View>
          <View style={[styles.tableColHeader, styles.nameCol]}>
            <Text style={styles.tableCellHeader}>Nome</Text>
          </View>
          <View style={[styles.tableColHeader, styles.countCol]}>
            <Text style={styles.tableCellHeader}>Contagem</Text>
          </View>
        </View>
        {data.map((item, itemIndex) => (
          <View
            style={
              itemIndex % 2 === 0 ? styles.tableRow : styles.tableRowAlternate
            }
            key={item.code + itemIndex}
            wrap={false}
          >
            <View style={[styles.tableCol, styles.codeCol]}>
              <Text style={styles.tableCell}>{item.code}</Text>
            </View>
            <View style={[styles.tableCol, styles.nameCol]}>
              <Text style={styles.tableCell}>{item.name}</Text>
            </View>
            <View style={[styles.tableCol, styles.countCol]}>
              <Text style={styles.tableCell}></Text>
            </View>
          </View>
        ))}
      </View>
    </PdfLayout>
  );
}
